<template>
    <b-card no-body class="mb-1">
        <div>
            <b-col sm="3">
                <label>{{ $t('an_meetschema', { ns: 'analytics' }) }}:</label>
            </b-col>
            <b-col sm="9">
                <b-input-group>
                    <b-form-select
                        v-if="!bewerk"
                        v-model="localSelected"
                        :options="flexList"
                        :disabled="disabled"
                        @change="set_input"
                    >
                        <template #first>
                            <b-form-select-option value=""
                                >--
                                {{ $t('com_selecteer', { ns: 'common' }) }}
                                --</b-form-select-option
                            >
                        </template>
                    </b-form-select>
                    <b-form-input
                        v-if="bewerk"
                        v-model="template.naam"
                        @change="templateChanged"
                    ></b-form-input>
                    <b-button
                        v-if="checkRight('AnalyticsEntityObjectCreate')"
                        size="sm"
                        @click="newTemplate()"
                        class="bgc_aux_normal"
                        ><font-awesome-icon icon="folder-plus" size="1x" />
                    </b-button>
                    <b-button
                        v-if="checkRight('AnalyticsEntityObjectCreate')"
                        size="sm"
                        @click="bewerkTemplate()"
                        class="bgc_aux_warning"
                        ><font-awesome-icon icon="edit" size="1x" />
                    </b-button>
                </b-input-group>
            </b-col>
        </div>
        <b-card no-body class="mb-1" v-if="bewerk">
            <b-form-textarea
                v-model="template.opmerking"
                :placeholder="$t('com_opmerking', { ns: 'common' })"
                rows="3"
                max-rows="6"
                @change="templateChanged"
            ></b-form-textarea>
            <div class="groups">
                <div class="group">
                    <b-card
                        :header="
                            $t('com_beschikbaar', {
                                ns: 'common',
                                val: $t('an_metingen', {
                                    ns: 'analytics'
                                }).toLowerCase()
                            })
                        "
                    >
                        <b-input-group size="sm">
                            <b-form-input
                                id="filter-input"
                                v-model="filter"
                                type="search"
                                :placeholder="
                                    $t('com_typetosearch', { ns: 'common' })
                                "
                                @input="filterList"
                            ></b-form-input>

                            <b-input-group-append>
                                <b-button
                                    :disabled="!filter"
                                    @click="filter = ''"
                                    >{{
                                        $t('com_wis', { ns: 'common' })
                                    }}</b-button
                                >
                            </b-input-group-append>
                        </b-input-group>

                        <b-col sm="1" />
                        <b-col sm="10">
                            <Container
                                group-name="MakeTemplate"
                                :get-child-payload="getChildPayload1"
                                @drop="onDrop('availableList', $event)"
                            >
                                <Draggable
                                    v-for="item in availableListFiltered"
                                    :key="item.id"
                                >
                                    <div class="draggable-item">
                                        {{ item.naam }}
                                    </div>
                                </Draggable>
                            </Container>
                        </b-col>
                    </b-card>
                </div>
                <div class="group">
                    <b-card header="Metingen in schema">
                        <Container
                            group-name="MakeTemplate"
                            :get-child-payload="getChildPayload2"
                            @drop="onDrop('selectedList', $event)"
                        >
                            <Draggable
                                v-for="item in selectedList"
                                :key="item.id"
                            >
                                <div class="draggable-item">
                                    {{ item.naam }}
                                </div>
                            </Draggable>
                        </Container>
                    </b-card>
                </div>
            </div>
        </b-card>
    </b-card>
</template>

<script>
import { Container, Draggable } from 'vue-dndrop';
import _ from 'lodash';
import Helper from '../../models/Helper';
import { Permission } from '../../models/Permissions';
import { TemplateObject } from '../../models/Anayltics';
import { loadList, loadItem } from './utils';
export default {
    name: 'TemplateObjectEditor',
    data: function () {
        return {
            errorMessage: '',
            localSelected: '',
            flexList: [],
            availableList: [],
            availableGroupedList: [],
            selectedList: [],
            bewerk: false,
            alterTemplate: false,
            template: null,
            forcerefresh: false,
            touched: false,
            grouped: 'grouped',
            filter: '',
            aangeraakt: 1,
            berichtWijziging: this.$t('an_warnwijzigopslaan', {
                ns: 'analytics'
            })
        };
    },
    model: {
        prop: 'selected',
        event: 'input'
    },
    props: {
        selected: {
            //type: Number
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    components: { Container, Draggable },
    watch: {},
    computed: {
        availableListFiltered() {
            // eslint-disable-next-line no-unused-vars
            const nep = this.aangeraakt;
            const list = this.availableList.filter((x) => !x.hide);
            return list;
        }
    },
    methods: {
        async fillLists() {
            const sel = await this.loadSelectedTemplateList();
            let avail = await this.loadAvailableList();
            // haal de sel uit avail
            const lists = Helper.reduceListWithList(avail, sel);
            avail = lists.list1;
            this.availableList = avail;
            this.selectedList = sel;
            const availGrouped = _(avail.slice(0))
                .groupBy((x) => x.grootheid)
                .map((value, key) => ({
                    grootheid: key,
                    iq: value
                }))
                .value();
            return availGrouped;
        },
        applyDrag(arr, dragResult) {
            const { removedIndex, addedIndex, payload } = dragResult;
            if (removedIndex === null && addedIndex === null) return arr;

            const result = [...arr];
            let itemToAdd = payload;

            if (removedIndex !== null) {
                itemToAdd = result.splice(removedIndex, 1)[0];
            }

            if (addedIndex !== null) {
                result.splice(addedIndex, 0, itemToAdd);
            }

            return result;
        },
        onDrop(collection, dropResult) {
            this.touched = true;
            this[collection] = this.applyDrag(this[collection], dropResult);
            this.$emit('touched', this.touched);
        },

        getChildPayload1(index) {
            return this.availableList[index];
        },

        getChildPayload2(index) {
            return this.selectedList[index];
        },
        checkRight(recht) {
            const id = Permission.enum(recht);
            return this.$root.handleRight(id);
        },
        set_input() {
            this.$emit('change', true);
            this.$emit('input', this.localSelected);
            //this.$emit('inputnaam', this.tekst);
        },
        newTemplate() {
            if (this.bewerk & this.touched) {
                this.saveTemplate();
            } else {
                this.template = new TemplateObject();
                this.selected = -1;
                this.fillLists();
            }
            this.bewerk = !this.bewerk;
        },
        async bewerkTemplate() {
            if (this.bewerk & this.touched) {
                await this.saveTemplate();
            } else {
                this.fillLists();
                this.template = await loadItem(
                    'analytics/loadTemplateObject',
                    { templateID: this.localSelected },
                    this.$t
                );
            }
            this.bewerk = !this.bewerk;
        },
        templateChanged() {
            this.alterTemplate = true;
            this.$emit('touched', this.alterTemplate);
        },
        async saveTemplate() {
            if (this.touched || this.alterTemplate) {
                const slaOp = await this.$root.showConfirmationBox(
                    this.berichtWijziging
                );
                if (slaOp) {
                    const o = this.template.SetForAdd();
                    o.InvestigationQuantiesIDs = this.selectedList.map(
                        (x) => x.id
                    );
                    this.selected = await loadItem(
                        'analytics/saveTemplateObject',
                        o,
                        this.$t
                    );
                    this.forcerefresh = true;
                    this.$emit('touched', false);
                }
            }
            this.touched = false;
        },
        filterList() {
            for (let i = 0; i < this.availableList.length; i++) {
                const item = this.availableList[i];
                item.hide = true;
                const test = item.naam.toLowerCase();
                const filt = this.filter.toLowerCase();
                if (filt.length > 0) {
                    if (test.indexOf(filt) > -1) item.hide = false;
                } else {
                    item.hide = false;
                }
            }
            this.aangeraakt += 1;
        },
        async loadTemplateList() {
            let templijst = await loadList(
                'analytics/getTemplateLijst',
                'analytics/loadTemplateLijst',
                null,
                this.forcerefresh,
                this.$t
            );
            templijst = Object.values(
                templijst.reduce((a, b) => {
                    if (!a[b.templateid]) a[b.templateid] = b;
                    return a;
                }, {})
            );
            this.flexList = templijst.map((x) => ({
                value: x.templateid,
                text: x.templatenaam,
                item: x
            }));
        },
        async loadSelectedTemplateList() {
            const complijst = await loadList(
                'analytics/getTemplateLijst',
                'analytics/loadTemplateLijst',
                null,
                this.forcerefresh,
                this.$t
            );
            const templijst = complijst.filter((c) => {
                return c.templateid == this.localSelected;
            });
            return templijst.map((x) => ({
                id: x.id,
                naam: x.naam,
                quantity: x.grootheid
            }));
        },
        async loadAvailableList() {
            const templijst = await loadList(
                'analytics/getIQLijst',
                'analytics/loadInvestQuantityLijst',
                null,
                this.forcerefresh,
                this.$t
            );
            return templijst.map((x) => ({
                id: x.id,
                naam: x.naam,
                quantity: x.grootheid
            }));
        }
    },
    mounted() {
        this.localSelected = this.selected ?? '';
    },
    async created() {
        await this.loadTemplateList();
    }
};
</script>

<style lang="css" scoped>
.groups {
    display: flex;
    justify-content: stretch;
}

.group {
    flex: 1;
}
</style>

